import './CardAppear.scss';
import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import { classList } from 'src/utils/classList';
import { transitionEndListener } from 'src/utils/transitionEndListener';

type Props = {
    readonly delay: number;
    readonly children: React.ReactElement;
    readonly className?: string;
};

export function CardAppear({ className, delay, children }: Props): JSX.Element {
    return (
        <CSSTransition in={true}
                       appear={true}
                       classNames="lvo-card-appear--animate"
                       timeout={10000}
                       addEndListener={transitionEndListener}
                       mountOnEnter={true}
                       unmountOnExit={true}>
            <div className={classList(className, 'lvo-card-appear')}
                 style={{ '--lvo-card-appear-delay': `${delay}ms` }}>
                {children}
            </div>
        </CSSTransition>
    );
}
